module.exports = __webpack_public_path__ + "static/chroma-key-bf8c01ca5b0d89817bf7cf465300cc51.png";